import { render, staticRenderFns } from "./array.vue?vue&type=template&id=1bc58109&scoped=true"
import script from "./array.vue?vue&type=script&lang=js"
export * from "./array.vue?vue&type=script&lang=js"
import style0 from "./array.vue?vue&type=style&index=0&id=1bc58109&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc58109",
  null
  
)

export default component.exports